import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, OnDestroy } from '@angular/core';
import { IsActiveMatchOptions } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { NavigationItem } from 'app/core/navigation/navigation.types';
import { HorizontalNavComponent } from './horizontal-nav.component';
import { randomId } from 'app/shared/utils/id.util';

const exactMatchOptions: IsActiveMatchOptions = { paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored' };
const subsetMatchOptions: IsActiveMatchOptions = { paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' };

@Component({
    selector: 'app-horizontal-nav-basic-item',
    templateUrl: './horizontal-nav-basic-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HorizontalNavBasicItemComponent implements OnInit, OnDestroy {
    @Input() item!: NavigationItem;
    @Input() name!: string;

    isActiveMatchOptions: IsActiveMatchOptions = subsetMatchOptions;
    private _parent?: HorizontalNavComponent;
    private _unsubscribeAll = new Subject<void>();

    constructor(
        private _cdr: ChangeDetectorRef,
        private _parentNav: HorizontalNavComponent
    ) {
        this._parent = _parentNav;
    }

    ngOnInit(): void {
        this.isActiveMatchOptions = this.item.isActiveMatchOptions ?? (this.item.exactMatch ? exactMatchOptions : subsetMatchOptions);
        this._parent?.onRefreshed.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => this._cdr.markForCheck());
        this._cdr.markForCheck();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
